export default "__VITE_ASSET__ONu1LHnC__"